export const TYPE_WEEK = "WEEK";
export const TYPE_MONTH = "MONTH";

export const TYPE_LIST = [TYPE_WEEK, TYPE_MONTH];

export const RANGE_LAST = "LAST";
export const RANGE_SPECIFIC = "SPECIFIC";

export const RANGE_LIST = [RANGE_LAST, RANGE_SPECIFIC];

export const RESULT_TYPE_PRICE = "Price";
export const RESULT_TYPE_QUANTITY = "Quantity";
export const RESULT_TYPE_PERCENT = "Percent";
export const RESULT_TYPE_TIME = "Time";
export const RESULT_TYPE_UNIT = "Unit";

export const RESULT_TYPE_LIST = [RESULT_TYPE_QUANTITY, RESULT_TYPE_PERCENT, RESULT_TYPE_TIME];
export const RESULT_TYPE_LIST_SELECT = [
    { value: RESULT_TYPE_QUANTITY, label: RESULT_TYPE_QUANTITY },
    { value: RESULT_TYPE_PERCENT, label: RESULT_TYPE_PERCENT },
    { value: RESULT_TYPE_TIME, label: RESULT_TYPE_TIME },
    { value: RESULT_TYPE_UNIT, label: RESULT_TYPE_UNIT },
];

/**
 * RESULT_TYPE_TIME
 */
export const VARIABLE_TYPE_TIME_ELAPSED_TIME_ON_RECEPTION = "ElapsedTimeOnReception";
export const VARIABLE_TYPE_TIME_ELAPSED_TIME_ON_ASSIGNMENT = "ElapsedTimeOnAssignment";
export const VARIABLE_TYPE_TIME_ELAPSED_DELAY_TIME_IN_DELIVERY = "ElapsedDelayTimeInDelivery";

export const VARIABLE_TYPE_PERCENT_JOB_ON_TIME = "On Time Jobs";
export const VARIABLE_TYPE_PERCENT_QA_AVG = "QA AVG";
export const VARIABLE_TYPE_PERCENT_QA_INTERNAL = "QA Internal";
export const VARIABLE_TYPE_PERCENT_QA_CLIENT = "QA Client";
export const VARIABLE_TYPE_PERCENT_QA_EXTERNAL = "QA External";

export const VARIABLE_TYPE_PERCENT_JOB_QA_AVG = "JobQA AVG";
export const VARIABLE_TYPE_PERCENT_JOB_QA_INTERNAL = "JobQA Internal";
export const VARIABLE_TYPE_PERCENT_JOB_QA_CLIENT = "JobQA Client";
export const VARIABLE_TYPE_PERCENT_JOB_QA_EXTERNAL = "JobQA External";

export const VARIABLE_TYPE_QUANTITY_JOBS = "Jobs #";

export const FILTER_ENTITY_ALL = "All";
export const FILTER_ENTITY_VENDOR = "Vendor";
export const FILTER_ENTITY_CLIENT = "Client";
export const FILTER_ENTITY_PROJECT = "Project";
export const FILTER_ENTITY_POINT_OF_SALE = "Point of Sale";
export const FILTER_ENTITY_COMPONENT = "Component";
export const FILTER_ENTITY_MANAGER = "Manager";

export const getVariableTypeListFor = (result) => {
    if (result === RESULT_TYPE_TIME) {
        return [
            { value: VARIABLE_TYPE_TIME_ELAPSED_TIME_ON_RECEPTION, label: "Elapsed Time On Reception" },
            { value: VARIABLE_TYPE_TIME_ELAPSED_TIME_ON_ASSIGNMENT, label: "Elapsed Time On Assignment" },
            { value: VARIABLE_TYPE_TIME_ELAPSED_DELAY_TIME_IN_DELIVERY, label: "Elapsed Delay Time In Delivery" },
        ];
    }

    if (result === RESULT_TYPE_PERCENT) {
        return [
            {
                label: "General",
                options: [{ value: VARIABLE_TYPE_PERCENT_JOB_ON_TIME, label: VARIABLE_TYPE_PERCENT_JOB_ON_TIME }],
            },
            {
                label: "QA",
                options: [
                    { value: VARIABLE_TYPE_PERCENT_QA_INTERNAL, label: VARIABLE_TYPE_PERCENT_QA_INTERNAL },
                    { value: VARIABLE_TYPE_PERCENT_QA_CLIENT, label: VARIABLE_TYPE_PERCENT_QA_CLIENT },
                    { value: VARIABLE_TYPE_PERCENT_QA_EXTERNAL, label: VARIABLE_TYPE_PERCENT_QA_EXTERNAL },
                    { value: VARIABLE_TYPE_PERCENT_QA_AVG, label: VARIABLE_TYPE_PERCENT_QA_AVG },
                ],
            },
            {
                label: "Job QA",
                options: [
                    { value: VARIABLE_TYPE_PERCENT_JOB_QA_INTERNAL, label: VARIABLE_TYPE_PERCENT_JOB_QA_INTERNAL },
                    { value: VARIABLE_TYPE_PERCENT_JOB_QA_CLIENT, label: VARIABLE_TYPE_PERCENT_JOB_QA_CLIENT },
                    { value: VARIABLE_TYPE_PERCENT_JOB_QA_EXTERNAL, label: VARIABLE_TYPE_PERCENT_JOB_QA_EXTERNAL },
                    { value: VARIABLE_TYPE_PERCENT_JOB_QA_AVG, label: VARIABLE_TYPE_PERCENT_JOB_QA_AVG },
                ],
            },
        ];
    }

    if (result === RESULT_TYPE_QUANTITY) {
        return [{ value: VARIABLE_TYPE_QUANTITY_JOBS, label: VARIABLE_TYPE_QUANTITY_JOBS }];
    }
};

export const getFilterEntitiesFor = (result, variable) => {
    if (result === RESULT_TYPE_TIME) {
        return [
            { value: FILTER_ENTITY_ALL, label: FILTER_ENTITY_ALL },
            { value: FILTER_ENTITY_CLIENT, label: FILTER_ENTITY_CLIENT },
            { value: FILTER_ENTITY_PROJECT, label: FILTER_ENTITY_PROJECT },
            { value: FILTER_ENTITY_POINT_OF_SALE, label: FILTER_ENTITY_POINT_OF_SALE },
            { value: FILTER_ENTITY_MANAGER, label: FILTER_ENTITY_MANAGER },
        ];
    }

    if (result === RESULT_TYPE_PERCENT) {
        if (
            [
                VARIABLE_TYPE_PERCENT_QA_AVG,
                VARIABLE_TYPE_PERCENT_QA_INTERNAL,
                VARIABLE_TYPE_PERCENT_QA_CLIENT,
                VARIABLE_TYPE_PERCENT_QA_EXTERNAL,
            ].indexOf(variable) > -1
        ) {
            return [
                { value: FILTER_ENTITY_ALL, label: FILTER_ENTITY_ALL },
                { value: FILTER_ENTITY_VENDOR, label: FILTER_ENTITY_VENDOR },
                { value: FILTER_ENTITY_CLIENT, label: FILTER_ENTITY_CLIENT },
                { value: FILTER_ENTITY_PROJECT, label: FILTER_ENTITY_PROJECT },
                { value: FILTER_ENTITY_POINT_OF_SALE, label: FILTER_ENTITY_POINT_OF_SALE },
                { value: FILTER_ENTITY_MANAGER, label: FILTER_ENTITY_MANAGER },
            ];
        }
        if (
            [
                VARIABLE_TYPE_PERCENT_JOB_QA_AVG,
                VARIABLE_TYPE_PERCENT_JOB_QA_INTERNAL,
                VARIABLE_TYPE_PERCENT_JOB_QA_CLIENT,
                VARIABLE_TYPE_PERCENT_JOB_QA_EXTERNAL,
            ].indexOf(variable) > -1
        ) {
            return [
                { value: FILTER_ENTITY_ALL, label: FILTER_ENTITY_ALL },
                { value: FILTER_ENTITY_CLIENT, label: FILTER_ENTITY_CLIENT },
                { value: FILTER_ENTITY_PROJECT, label: FILTER_ENTITY_PROJECT },
                { value: FILTER_ENTITY_POINT_OF_SALE, label: FILTER_ENTITY_POINT_OF_SALE },
                { value: FILTER_ENTITY_MANAGER, label: FILTER_ENTITY_MANAGER },
            ];
        }
        return [
            { value: FILTER_ENTITY_ALL, label: FILTER_ENTITY_ALL },
            { value: FILTER_ENTITY_CLIENT, label: FILTER_ENTITY_CLIENT },
            { value: FILTER_ENTITY_PROJECT, label: FILTER_ENTITY_PROJECT },
            { value: FILTER_ENTITY_POINT_OF_SALE, label: FILTER_ENTITY_POINT_OF_SALE },
            { value: FILTER_ENTITY_MANAGER, label: FILTER_ENTITY_MANAGER },
        ];
    }

    if (result === RESULT_TYPE_UNIT) {
        return [
            { value: FILTER_ENTITY_ALL, label: FILTER_ENTITY_ALL },
            { value: FILTER_ENTITY_CLIENT, label: FILTER_ENTITY_CLIENT },
            { value: FILTER_ENTITY_PROJECT, label: FILTER_ENTITY_PROJECT },
            { value: FILTER_ENTITY_POINT_OF_SALE, label: FILTER_ENTITY_POINT_OF_SALE },
            { value: FILTER_ENTITY_VENDOR, label: FILTER_ENTITY_VENDOR },
        ];
    }
};
